import { csl, u_ } from "@pressmedia/webappbase";
import _fUploaderProps from "./_fUploaderProps";

export default {
	_fUploaderProps,
	
	getFileUploaderProps(dataType) {
		if( !dataType || !u_.isString(dataType) ) {
			throw new TypeError("arguments[0] must be string and is required.");
		}
		
		const vuwForm = this.getForm();
		if(!vuwForm) {
			csl.warn(`Using file uploader, ${this.klass} must be VuwForm's child.`);
			return false;
		}
		
		const props = {
			dataType: dataType,
			ACTION_URL: vuwForm.ACTION_URL,
			showLoading: vuwForm.showLoading.bind(vuwForm),
			hideLoading: vuwForm.hideLoading.bind(vuwForm),
			ajaxErrorCallback: vuwForm.ajaxErrorCallback,
			inpFileName: `${this.paramKey}[${dataType}]`,
			inpFileId: `inp_${this.idStr}_fu_${dataType}`,
			...this._fUploaderProps
		};
		
		if(
			u_.isObject(vuwForm.config.maxFileSize) &&
			vuwForm.config.maxFileSize[dataType]
		) {
			props.maxFileSize = vuwForm.config.maxFileSize[dataType];
		}
		
		return props;
	}
};
